// Фасад API-клиента. Типы и методы разнесены по доменам в api/*.ts;
// здесь — реэкспорт всех типов и сборка объекта api из доменных
// фрагментов. Публичная поверхность не изменилась (Фаза 1).

export type * from "./api/media";
export type * from "./api/common";
export type * from "./api/me";
export type * from "./api/campaign";
export type * from "./api/invitation";
export type * from "./api/setup";
export type * from "./api/world";
export type * from "./api/character";
export type * from "./api/continuity";
export type * from "./api/threat";
export type * from "./api/commandHub";
export type * from "./api/relationship";
export type * from "./api/infrastructure";
export type * from "./api/beta";
export type * from "./api/action";
export type * from "./api/discussion";
export type * from "./api/initiative";
export type * from "./api/chronicle";
export type * from "./api/cycle";

import { mediaApi } from "./api/media";
import { meApi } from "./api/me";
import { campaignApi } from "./api/campaign";
import { invitationApi } from "./api/invitation";
import { setupApi } from "./api/setup";
import { worldApi } from "./api/world";
import { betaApi } from "./api/beta";
import { actionApi } from "./api/action";
import { discussionApi } from "./api/discussion";
import { initiativeApi } from "./api/initiative";
import { cycleApi } from "./api/cycle";

export const api = {
  ...mediaApi,
  ...meApi,
  ...campaignApi,
  ...invitationApi,
  ...setupApi,
  ...worldApi,
  ...betaApi,
  ...actionApi,
  ...discussionApi,
  ...initiativeApi,
  ...cycleApi,
};
